<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="filter-wrapper">
                    <p class="title">Manage Filters:</p>
                    <div class="filter-container">
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.company" @change="filter_list">
                                <option value="all">Company: All</option>
                                <option v-for="value in companies" :value="value" :key="value">{{ value }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.role" @change="filter_list">
                                <option value="all">Role: All</option>
                                <option v-for="value in roles" :value="value" :key="value">{{ value }}</option>
                            </select>
                        </div>
                        <div class="filter-item search-filter">
                            <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                            <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="filter-reset-btn">
                            <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj" @scroll="scroll_list">
                        <div class="row list-head">
                            <div class="col sort-false col-check-th"><input type="checkbox" v-model="default_select_all_user" @change="select_all_users"></div>
                            <div class="col" data-key="username" @click="sort_list">Name</div>
                            <div class="col" data-key="company" @click="sort_list">Company</div>
                            <div class="col" data-key="bp_code" @click="sort_list">BP Code</div>
                            <div class="col" data-key="role" @click="sort_list">Role</div>
                            <div class="col sort-false" v-if="user.role == 'administrator' || user.role == 'ses-support'">Actions</div>
                        </div>
                        <div class="list-row" v-for="(row, key) in users" :key="row.id">
                            <div class="row list-data">
                                <div class="col col-check-td"><input type="checkbox" :checked="selected_users.indexOf(row.id) != -1" @change="select_user($event, row.id)"></div>
                                <div class="col">{{ row.username }}</div>
                                <div class="col">{{ row.company }}</div>
                                <div class="col">{{ row.bp_code }}</div>
                                <div class="col">{{ row.role }}</div>
                                <div class="col" v-if="user.role == 'administrator' || user.role == 'ses-support'">
                                    <router-link :to="'/user/'+row.id">Edit</router-link>
                                    <a v-if="user.role == 'administrator'" href="javascript:void(0);" @click="delete_user(key, row.id)">Delete</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="users.length == 0 && !isListLoading">
                        <p class="no-results-msg">No results found</p>
                    </template>
                    <template v-if="isListLoading">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="button-group">
                    <div class="btn-bulk-edit position-relative" v-if="user.role == 'administrator' && selected_users.length > 0">
                        <button class="btn" @click="showBulkEditModal = true">Bulk Edit ({{ selected_users.length }})</button>
                        <button class="btn btnDeselectAllUser" title="Deselect All Users" @click="deselect_all_users">&times;</button>
                    </div>
                    <router-link :to="'/user/new'" class="btn btn-black" v-if="user.role == 'administrator'">New User</router-link>
                    <a class="btn btn-black" :href="`/api/users/export?filters=${JSON.stringify(filters)}&auth=${user.token}&order_by=${order_by}&order=${order}`" data-export>Export Users</a>
                </div>
            </div>
        </div>

        <user-bulk-edit-modal :show="showBulkEditModal" :ids="selected_users" @close="closeBulkEditModal"></user-bulk-edit-modal>
    </div>
</template>
<script>
import UserBulkEditModal from '../../components/Modals/UserBulkEditModal'

export default {
    name: 'users',
    components: { UserBulkEditModal },
    data() {
        return {
            apiUrl: '/api/',
            users: [],
            isListLoading: false,
            page: 1,
            last_page: 1,
            order_by: 'username',
            order: 'asc',
            filters: {
                search: '',
                company: 'all',
                role: 'all'
            },
            companies: [],
            roles: [],
            default_select_all_user: false,
            selected_users: [],
            select_all_user_filters: [],
            showBulkEditModal: false
        }
    },
    mounted() {
        let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        // this.loadUsers()
        this.get_user_filters()
    },
    methods: {
        loadUsers() {
            var user = localStorage.getItem('user');
            if ( !user ) this.$router.push('login');
            this.user = JSON.parse(user);

            const api = this.apiUrl+'users?page=' + this.page 
                            + '&order_by=' + this.order_by
                            + '&order=' + this.order
                            + '&auth=' + this.user.token
                            + '&filters=' + JSON.stringify(this.filters);

            this.isListLoading = true;
            this.$http.get(api).then((response) => {
                if(this.page == 1) {
                    this.users = [];
                }
                response.data.data.forEach(row => {
                    this.users.push(row);
                })
                this.last_page = response.data.last_page
                this.isListLoading = false;


                let filters = JSON.stringify(this.filters)
                if(this.select_all_user_filters.indexOf(filters) != -1) {
                    this.default_select_all_user = true
                } else {
                    this.default_select_all_user = false
                }
            });
        },
        get_user_filters() {
            this.$http.get('/api/users/filters').then((response) => {
                this.companies = response.data.companies
                this.roles = response.data.roles
            })
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.loadUsers()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.users = []
              this.loadUsers()
            }
        },
        filter_list() {
            this.page = 1
            this.users = []
            this.loadUsers()
        },
        reset_filter() {
            this.filters = {
                search: '',
                company: 'all',
                role: 'all'
            }
            this.page = 1
            this.users = []
            this.loadUsers()
        },
        select_all_users(e) {
            // save select all filter
            let filters = JSON.stringify(this.filters)
            if(e.target.checked) {
                if(this.select_all_user_filters.indexOf(filters) == -1) {
                    this.select_all_user_filters.push(filters)
                }
            } else {
                this.select_all_user_filters.splice(this.select_all_user_filters.indexOf(filters), 1)
            }

            // select all user
            let ids = this.users
            for(let n in ids) {
                this.select_user(e, ids[n].id)
            }
        },
        select_user(e, id) {
            if(e.target.checked) {
                if(this.selected_users.indexOf(id) == -1) {
                    this.selected_users.push(id)
                }
            } else {
                this.selected_users.splice(this.selected_users.indexOf(id), 1)
            }
        },
        deselect_all_users() {
            this.default_select_all_user = false
            this.selected_users = []
            this.select_all_user_filters = []
        },
        closeBulkEditModal() {
            this.showBulkEditModal = false
            this.loadUsers()
        },
        delete_user(key, id) {
            let conf = confirm('Are you sure you want to delete this user?')
            if(conf) {
                this.$http.delete('/api/users/' + id)
                    .then(() => {
                        this.users.splice(key, 1)
                        alert('Deleted user!')
                    })
                    .catch(() => {
                        alert('Something went wrong!')
                    })
            }
        }
    },
    beforeMount(){
        this.loadUsers()
    }
};
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    max-height: 500px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.col-check-th,
.col-check-td {
    flex-grow: 0;
}
.col-check-th {
    padding-left: 32px;
}
.col-check-td {
    padding-left: 25px;
}
.btnDeselectAllUser {
    background-color: #c90000;
    color: #fff;
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 24px !important;
    padding: 0;
    position: absolute;
    z-index: 10;
    right: -14px;
    top: -9px;
    &:hover {
        color: #000;
    }
}
.button-group {
    .btn-bulk-edit {
        width: 100%;
        margin-right: 0;
        .btn {
            width: 100%;
        }
    }
}
@media (min-width: 568px) {
    .button-group {
        .btn-bulk-edit {
            width: 48%;
            margin-right: 8px;
        }
    }
}
@media (min-width: 992px) {
    .button-group {
        .btn-bulk-edit {
            width: auto;
        }
    }
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
</style>
